<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" :disabled="!select.Id" @click="create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="80">
              <template slot-scope="{ row }">
                <el-button v-if="$permission.canWrite()" type="text" @click="edit(row)">编辑</el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </div>
    </div>

    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/basedata/basedoc/accessstock/list";
import editDialog from "@/components/basedata/basedoc/accessstock/editDialog";
import typeTree from "@/components/basedata/basedoc/accessstock/type/tree";

export default {
  name: "business",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    typeTree,
  },
  data() {
    return {
      select: {
        Pid:null,
        Id: null,
        Name: "",
      },

    };
  },

  methods: {
    create() {
      // console.log("select", this.select);
      const Id  = this.select.Pid === 0 ?  this.select.Id : this.select.Pid
      this.$refs.editDialog.openCreate({ Pid: Id });
    },

    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ClassId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
    onSelect(data) {
      // console.log('data',data);
      this.select.Pid = data.Pid;
      this.select.Id = data.ClassId;
      this.select.Name = data.ClassName;
      const classId = data.Pid === 0 ? data.ClassId : data.Pid
      // this.$refs.list.getData({ ClassType:16, Pid:classId });
      this.$refs.list.getData({ ClassType:16, Pid:classId }).then((that)=>{        
      // Object.assign(that.data,that.data.filter(i=>i.PclassName == data.PclassName))
      });
      
      this.reload();
    },
    titleClick() {
      this.select.Id = null;
      this.select.Name = "";
      this.$refs.list.getData({ IdChain: null });
    },
  },
};
</script>
